import React, { LegacyRef, useCallback, useEffect, useState } from 'react';
import Modal from 'react-modal';
import ImageGallery from 'react-image-gallery';
import Icon from '../components/Icons/Icon';
import { RetrieveSubmissions, setPageNum, updateSubmission, Submission, Status } from './services/submissions';
import ReactImageGallery from 'react-image-gallery';
import SubmissionCard from './SubmissionCard';
import { checkExport, startExport } from '../helpers/galleryHelper';
import moment from 'moment';
import { decodeHtmlCharCodes } from '../helpers/textHelper';


const generateReportDates = () => {
    let startob = moment('2022-05-02', 'YYYY-MM-DD');
    let start = startob.format('YYYY-MM-DD');
    let index = startob.add(6, 'days');
    let arr = [];
    arr.push(start + " - " + index.format('YYYY-MM-DD'));

    while (index.isBefore(moment())) {
        index.add(1, 'day');
        arr.push(index.format('YYYY-MM-DD') + " - " + index.add(6, 'days').format('YYYY-MM-DD'))
    }
    return arr;
}

const AdminGallery = () => {
    const galleryRef = React.useRef();
    const currentIndex = React.useRef(-1);
    const [loading, setLoading] = useState(true);
    const [awaitingExport, setAwaitingExport] = useState(-1);
    const [exportUrl, setExportUrl] = useState('');
    const [modalIsOpen, setModalIsOpen] = useState(false);
    // const [currentIndex, setCurrentIndex] = useState(-1);
    const [counter, setCounter] = useState(0);
    const [filter, setFilter] = useState<Status>("");
    const [submissions, setSubmissions] = useState<Submission[]>([]);
    const [counts, setCounts] = useState({
        all: 0,
        pending: 0,
        rejected: 0,
        approved: 0,
        promoted: 0,
        '': 0 
    })
    const [availableReportDates, setAvailableReportDates] = useState(generateReportDates);
    const [selectedReportDate, setSelectedReportDate] = useState(availableReportDates[0]);
    
    const retryExportStatus = useCallback((current_iter: number) => {
        if (current_iter < 5) {
            setTimeout(()=>{
                checkExport(awaitingExport)
                .then((res: any) => {
                    if (res === 'empty') {
                        setAwaitingExport(-1);
                        setExportUrl('No submissions for that date');
                    } else if (res) {
                        console.log('export ready:');
                        console.log(res);
                        setAwaitingExport(-1);
                        setExportUrl(res.data.exportResult.exportedUrl);
                    } else {
                        console.log('--- export not ready ----');
                        retryExportStatus(current_iter + 1)
                    }
                })
                .catch((err)=>{
                    console.log('err');
                    console.log(err);
                })
            }, 500)
        } else {
            return false;
        }
    }, [awaitingExport])

    useEffect(()=> {
        const getSubmissions = async () => {
            let new_rows = await RetrieveSubmissions(filter);
            setSubmissions(new_rows);
            setLoading(false);
        }
        setSubmissions([]);
        setPageNum(1);
        getSubmissions();
    }, [filter])

    useEffect(()=> {
        if (filter === "") {
            // count number of each status submissions
            let temp_counts = {
                   all: 0,
                   pending: 0,
                   rejected: 0,
                   approved: 0,
                   promoted: 0,
                   '': 0
            }
            submissions.forEach((sub) => {
                temp_counts[sub.status]++;
                temp_counts['all']++;
            });
            setCounts(temp_counts);
        }
    }, [filter, submissions])

    useEffect(()=> {
        if (awaitingExport !== -1) {
            retryExportStatus(0);
        }
    }, [awaitingExport, retryExportStatus])

    const updateStatus = useCallback((target_status: Status) => {
        updateSubmission(submissions[currentIndex.current]?.id, target_status)
        .then((res: Submission) => {
            if (currentIndex.current !== -1 && res && submissions[currentIndex.current]) {
                let temp = submissions;
                if (temp[currentIndex.current] !== null) {
                    temp[currentIndex.current].status = res.status;
                }
                setSubmissions(temp);
                setCounter(counter + 1); //trigger re-render
            }
        })
    }, [counter, submissions])

    const handleKeyDown = (e: any) => {
        if (e.key && currentIndex.current !== -1) {
            switch(e.key) {
                case 'q': {updateStatus('rejected'); break;}
                case 'w': {updateStatus('approved'); break;}
                case 'e': {updateStatus('promoted'); break;}
            }
        }
    }

    const openModal = (id: number) => {
        console.log('opening ' + id)
        currentIndex.current = id;
        setModalIsOpen(true);
        document.addEventListener('keydown', handleKeyDown);
    }

    const closeModal = () => {
        currentIndex.current = -1;
        setModalIsOpen(false);
        document.removeEventListener('keydown', handleKeyDown);
    }

    return (
        <div>
            {loading ? "Loading..." 
            : 
                <>
                    <div>
                        <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'space-between'}}>
                            <div className="H5" style={{fontWeight: 'bold', textAlign: 'left'}}>
                                Submissions
                            </div>
                            <div className='H5' style={{textAlign: 'right'}}>
                                Export Submissions
                            </div>
                        </div>
                        <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'space-between'}}>
                            <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'space-evenly', width: 800, marginTop: 16, height: 'min-content'}}>
                                <div className={"admin-filter P2" + (filter === '' ? ' active' : '')} onClick={()=> {setFilter('')}}>
                                    All ({counts.all})
                                </div>
                                <div className={"admin-filter P2" + (filter === 'pending' ? ' active' : '')} onClick={()=> {setFilter('pending')}}>
                                    Pending ({counts.pending})
                                </div>
                                <div className={"admin-filter P2" + (filter === 'rejected' ? ' active' : '')} onClick={()=> {setFilter('rejected')}}>
                                    Rejected ({counts.rejected})
                                </div>
                                <div className={"admin-filter P2" + (filter === 'approved' ? ' active' : '')} onClick={()=> {setFilter('approved')}}>
                                    Approved ({counts.approved})
                                </div>
                                <div className={"admin-filter P2" + (filter === 'promoted' ? ' active' : '')} onClick={()=> {setFilter('promoted')}}>
                                    Promoted ({counts.promoted})
                                </div>
                            </div>
                            <div style={{marginTop: 16}}>
                                <select style={{marginRight: 24}} onChange={(ev) => {setSelectedReportDate(ev.target.value)}}>
                                    {availableReportDates.map((item, index)=> {
                                        return (
                                            <option value={item} key={item}>{item}</option>
                                        )
                                    })}
                                </select>
                                <span className="P3" style={{cursor: 'pointer', fontWeight: 'bold', textAlign: 'left', textDecoration: 'underline'}} onClick={()=>{
                                    let reportDate = selectedReportDate.split(' - ')
                                    startExport(reportDate[0], moment(reportDate[1]).add(1, 'day').format('YYYY-MM-DD'))
                                    .then((res) => {
                                        console.log(res);
                                        setAwaitingExport(res.id)
                                    })
                                }}>
                                    {awaitingExport !== -1 ? 'Exporting...' : 'Start Export'}
                                </span>
                                {
                                awaitingExport === -1 && exportUrl === 'No submissions for that date' ? <div className='P3'>No submissions for that date</div> 
                                : awaitingExport === -1 && exportUrl ? <div className='P3' style={{cursor: 'pointer', textDecoration: 'underline'}} onClick={()=>{window.open(exportUrl)}}>{exportUrl === 'No submissions for that date' ? 'No submissions for that date' : 'Save Report'}</div> 
                                    : null
                                }
                            </div>
                        </div>
                        <div className="P2" style={{padding: 16, display: 'flex', flexDirection: 'row', flexWrap: 'wrap', flex: 1}}>
                            {submissions.map((submission) => {
                                return (
                                    <div key={submission.id}>
                                        <SubmissionCard submission={submission} openModal={openModal} />
                                    </div>
                                )}
                            )}
                        </div>
                    </div>
                </>
            }
            <Modal
                isOpen={modalIsOpen}
                onRequestClose={closeModal}
                style={{content: {backgroundColor: 'black'}}}
            >
                <ImageGallery 
                    items={submissions} 
                    additionalClass="gallery-container" 
                    ref={galleryRef as unknown as LegacyRef<ReactImageGallery>} 
                    startIndex={currentIndex.current} 
                    slideDuration={300}
                    lazyLoad
                    onSlide={(num) => {currentIndex.current = num; setCounter(counter + 1)}}
                    renderCustomControls={useCallback(()=> {
                        return (
                            <div style={{flexDirection: 'row', display: 'flex', flex: 1, color: 'white', width: 100, justifyContent: 'space-evenly'}}>
                                <div style={{display: 'flex', flexDirection: 'column', justifyContent: 'space-between', alignItems: 'center', height: 32, fontWeight: 'bold', color: 'grey'}}>
                                    <div style={submissions[currentIndex.current]?.status === 'rejected' ? {color: 'red'} : {color: 'white', cursor: 'pointer'}}>
                                        <Icon name="Trash" onClick={()=>{
                                            updateStatus('rejected');
                                        }}/>
                                    </div>
                                    Q
                                </div>
                                <div style={{display: 'flex', flexDirection: 'column', justifyContent: 'space-between', alignItems: 'center', height: 32, fontWeight: 'bold', color: 'grey'}}>
                                    <div style={submissions[currentIndex.current]?.status === 'approved' ? {color: 'green'} : {color: 'white', cursor: 'pointer'}}>
                                        <Icon name="SuccessForm" onClick={()=>{
                                            updateStatus('approved');
                                        }}/>
                                    </div>
                                    W
                                </div>
                                <div style={{display: 'flex', flexDirection: 'column', justifyContent: 'space-between', alignItems: 'center', height: 32, fontWeight: 'bold', color: 'grey'}}>
                                    <div style={submissions[currentIndex.current]?.status === 'promoted' ? {color: 'gold'} : {color: 'white', cursor: 'pointer'}}>
                                        <Icon name="ArrowUp" onClick={()=>{
                                            updateStatus('promoted');
                                        }}/>
                                    </div>
                                    E
                                </div>
                            </div>
                        )
                    }, [submissions, currentIndex, updateStatus])}
                    renderPlayPauseButton={()=> {
                        return (
                            <div className="gallery-location-text">
                                <Icon name="Pin" className="shadowed"/>
                                {decodeHtmlCharCodes(submissions[currentIndex.current]?.location)}
                            </div> 
                        )
                    }}
                />
                <div style={{position: 'absolute', right: 16, top: 16, zIndex: 5, color: 'white'}} onClick={closeModal}>
                    <Icon name="Close" size={32} className="shadowed"/>
                </div>
            </Modal>
        </div>
    )
}

export default AdminGallery;